<template>
    <div 
        id="modal-container" 
        v-if="visible"
        class="modal-overlay"
        @click.self="handleOutsideClick"
    >

        <div class="modal-content">
            <h2>Emin misiniz?</h2>
            <p>Gerçekten ilgili resmi silmek istiyor musunuz? Bu işlem geri alınamaz.</p>
            <div class="modal-actions">
                <button @click="deleteImage(orderNo)">Evet</button>
                <button @click="$emit('cancel')">Hayır</button>
            </div>
        </div>
        
    </div>
</template>

<script>
import axios from 'axios';

export default{
    props:{
        visible: {
            type: Boolean,
            required: true
        },
        orderNo: {
            type: Number,
            required: true
        },
        isExhibition: {
            type: Boolean,
            required: true
        }
    },

    emits:["confirm", "cancel"],

    methods: {
        //Closing modals without clicking button
        handleKeyPress(event) {
            if (event.key === 'Escape') {
                this.$emit('cancel');
            }
        },
        handleOutsideClick() {
            this.$emit('cancel');
        },

        async deleteImagePortfolio(orderNo){
            try {
                // API çağrısını asenkron şekilde bekle
                await axios.delete("/api-path/Portfolio/delete-images", {
                    data: [orderNo]  // API'nin beklediği gibi JSON formatında dizi olarak gönderiyoruz.
                });

                alert("Silme işlemi başarılı!");
            } catch (error) {
                console.error("API call failed:", error);
            }
        },

        async deleteImageExhibition(orderNo){
            try {
                // API çağrısını asenkron şekilde bekle
                await axios.delete("/api-path/Exhibition/delete-images", {
                    data: [orderNo]  // API'nin beklediği gibi JSON formatında dizi olarak gönderiyoruz.
                });

                alert("Silme işlemi başarılı!");
            } catch (error) {
                console.error("API call failed:", error);
            }
        },

        deleteImage(orderNo){
            if(!this.isExhibition){
                console.log("PORTFOLYO");
                this.deleteImagePortfolio(orderNo);
            }
            if(this.isExhibition){
                console.log("SERGİ");
                this.deleteImageExhibition(orderNo);
            }
            this.$emit('confirm', orderNo);
        }
    },

    mounted() {
        document.addEventListener('keydown', this.handleKeyPress);
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
    },
    
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.modal-actions button {
    margin: 10px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.modal-actions button:first-of-type {
    background: #e74c3c;
    color: white;
}

.modal-actions button:last-of-type {
    background: #bdc3c7;
}

</style>